module.exports = __webpack_public_path__ + "img/about-dx.80104dda.png";